import { render, staticRenderFns } from "./MountFormExtraFields.vue?vue&type=template&id=959b8a2a&scoped=true&"
import script from "./mountFormExtraFields.ts?vue&type=script&lang=ts&"
export * from "./mountFormExtraFields.ts?vue&type=script&lang=ts&"
import style0 from "./MountFormExtraFields.vue?vue&type=style&index=0&id=959b8a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959b8a2a",
  null
  
)

export default component.exports